import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useError } from "../../../Events/UI/ErrorContext";
import { config } from "../../../authConfig";

const useUserRoles = () => {
  const { instance } = useMsal();
  const [roles, setRoles] = useState<string[]>([]);
  const { setError } = useError();
  // Preparing the loading state
  const [isLoading, setIsLoading] = useState<boolean>(false);


  useEffect(() => {
    if (instance.getActiveAccount() !== null) {
      let account = instance.getActiveAccount();
      fetchRoles(account?.username || "");
    }
  }, [instance]);

  const fetchRoles = function (email: string) {
    setIsLoading(true);
    const url = (config.rootAPIList?.allUserPermissions ?? '')
      .replace("{applicationName}", config.applicationName)
      .replace("{email}", email);

      fetch(`${config.rootAPIUrl}${url}`, { method: "GET"})
      .then(async (value) => {
        if (value.ok) {
          var result = await value.json();
          var res = result.map((x: any) => x.name);
          setRoles(res);
        } else {
          var nok = await value.text();
          setRoles([]);
        }
      })
      .catch((error) => {
        console.log(error);
          setRoles([]);
          setError(error);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  return roles;
};

export default useUserRoles;
